import { z } from 'zod'

import ZBaseAction from './base'

const ZReopenAction = ZBaseAction.extend({
  reopen: z.object({
    campId: z.string(),
  }),
})

export default ZReopenAction
